export const APP_NAME = 'Harav Osher Dovid May'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
